import { PropsWithChildren } from "react";
import { Link, useLocation, useParams } from "react-router-dom";

type PageScaffoldProps = PropsWithChildren<{
  title: string;
  description?: string;
  links?: Array<{ to: string; label: string }>;
}>;

export function PageScaffold({
  title,
  description,
  links = [],
  children
}: PageScaffoldProps) {
  const { tenantSlug = "unknown-tenant" } = useParams();
  const location = useLocation();

  return (
    <main style={{ maxWidth: 720, margin: "0 auto", padding: 16 }}>
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 12, opacity: 0.7 }}>テナント: {tenantSlug}</div>
        <h1 style={{ margin: "8px 0 12px" }}>{title}</h1>
        {description ? <p style={{ margin: "0 0 12px" }}>{description}</p> : null}
      </div>

      {links.length > 0 ? (
        <nav style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to.replace(":tenantSlug", tenantSlug)}
              style={{
                display: "inline-block",
                padding: "8px 12px",
                border: "1px solid #ccc",
                borderRadius: 8,
                textDecoration: "none"
              }}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      ) : null}

      {!location.pathname.endsWith("/support") ? (
        <nav style={{ marginBottom: 16 }} aria-label="サポート">
          <Link
            to={`/t/${tenantSlug}/support`}
            style={{ display: "inline-block", padding: "8px 12px", border: "1px solid #ccc", borderRadius: 8, textDecoration: "none" }}
          >
            サポート
          </Link>
        </nav>
      ) : null}

      <section
        style={{
          padding: 16,
          border: "1px solid #e5e5e5",
          borderRadius: 12,
          background: "#fff"
        }}
      >
        {children}
      </section>
    </main>
  );
}
